module.exports = __webpack_public_path__ + "static/media/vanguard.fe1f909d.webp";